export const isTestEnvironment =
  process.env.REACT_APP_ENV === "testing" ||
  (typeof window !== "undefined" && window.location.hostname.includes("test."));

export const isProduction =
  process.env.REACT_APP_ENV === "production" && !isTestEnvironment;
